export default __webpack_public_path__ + "static/media/7829BAC2-12DD-4A54-8756-89D15B34BB9A_1_105_c.2b452b57.jpeg";